export function formEvents() {
	const forms = document.querySelectorAll(".gform_wrapper");
	if (!forms.length) return;

	const observer = new IntersectionObserver(
		(entries, obs) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) return;

				obs.unobserve(entry.target);

				(async () => {
					try {
						const { initForm } = await import("./form.js");
						initForm(entry.target);
					} catch (err) {
						console.error("Failed to load module:", err);
					}
				})();
			});
		},
		{ threshold: 0.1 }
	);

	forms.forEach((form) => observer.observe(form));
}
